export default __webpack_public_path__ + "static/falcevaya-krovlya-efe4fca94779f99ff94c7715cad0ed26.jpg";